import { Box, Grid, GridItem, IconWalletLight, skinVars, useScreenSize } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import type { PixData } from "../../components";
import { HeroDataInfo, ScreenResponsive, TabContent, WithdrawPix } from "../../components";
import { useGlobalStore } from "../../contexts/globalStoreContext";
import { formatDocumentNumber } from "../../utils/formatters";

import { useAnalytics } from "../../hooks/useAnalytics";
import { strings } from "../../localization";
import { PaymentInfoEnum } from "../../stores";
import { useNavigateCustom } from "../../hooks";

const WithdrawPaymentInfo: React.FC = observer(() => {
	const navigate = useNavigateCustom();
	const {
		anticipationStore: store,
		authenticationStore: { currentUser },
		paymentInfo,
	} = useGlobalStore();

	const {
		updatePageView,
		addAnalyticEvent,
		addAnalyticEventPurchase,
	} = useAnalytics();

	const { isTabletOrSmaller } = useScreenSize();
	const { title, description, descriptionMobile, descriptionDesktop, tabsTitle } = strings.pages.withdrawPaymentInfo;

	const { buttonPrimary } =
    strings.components.withdrawPix;

	const disbursementValues = store.partialAnticipationShelf.partialSimulationData;

	const analyticsInteractions = [
		async () => addAnalyticEvent({ step: "fgts:recebimento:pix", action: "click.button", description: tabsTitle[0]}, { applySanitize: true }),
		async () => addAnalyticEvent({ step: "fgts:recebimento:transferencia", action: "click.button", description: tabsTitle[1] }, { applySanitize: true }),
	];

	const onConfirmData = (data: PixData, type: PaymentInfoEnum): void => {
		paymentInfo.transferType.set(type);
		paymentInfo.pixKey.set(data.pixKey);
		paymentInfo.pixKeyType.set(data.pixKeyType);

		if (type === PaymentInfoEnum.PIX) {
			addAnalyticEvent({ step: "fgts:recebimento:pix", action: "click.button", description: buttonPrimary }, { applySanitize: true });
		}

		addAnalyticEventPurchase({
			event: "add_payment_info",
			ecommerce: {
				payment_type: `${ type === PaymentInfoEnum.PIX ? "pix" : "transferencia-bancaria"}`,
			},
			item: {
				item_name: `antecipacao-${"partial"}-fgts`,
				price: disbursementValues.value?.disbursedIssueAmount,
			},
		});

		return navigate("/withdraw-resume");
	};

	useEffect(() => {
		updatePageView({
			name: "Vivo Money FGTS Recebimento Pix",
			pagePath: "/fgts/recebimento/pix",
		});
	}, []);

	return (
		<ScreenResponsive onBack={() => navigate(-1)} navigationTitle={strings.pages.navigation.anticipation}>
			<Box paddingTop={32}>
				<Grid gap={32} columns={{ maxSize: 600 }} justifyContent={"center"}>
					<GridItem alignSelf="center">
						<HeroDataInfo
							icon={<IconWalletLight color={skinVars.colors.brand} size={64} />}
							title={title}
							description={description}
						/>
						<Grid columns={{ maxSize: 473 }} justifyContent={"center"}>
							<Box paddingBottom={32} paddingTop={isTabletOrSmaller ? 24 : 40}>
								<TabContent
									withBorder={false}
									analytics={analyticsInteractions}
									contents={[
										<WithdrawPix
											key={1}
											documentNumber={formatDocumentNumber(currentUser?.documentNumber || "")}
											description={isTabletOrSmaller ? descriptionMobile : descriptionDesktop}
											title={tabsTitle[0]}
											onContinue={(data) => onConfirmData(data, PaymentInfoEnum.PIX)}
										/>,
									]}
								/>
							</Box>
						</Grid>
					</GridItem>
				</Grid>
			</Box>
		</ScreenResponsive>
	);
});

export default WithdrawPaymentInfo;
